module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/trophy-cdfebd54638d0122ff0264025361b091.svg";